import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../firebase";
import { doc, getDoc } from "firebase/firestore";
import ClassRanking from "./bolumler/ClassRanking";
import ReactTable2 from "../../../components/tables/ReactTable2";

function StudentClass() {
  const { classUid } = useParams();
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const uid = user ? user.uid : null;
  const [homeworks, setHomeworks] = useState([]);
  const [className, setClassName] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const classRef = doc(db, "classes", classUid);
        const classDoc = await getDoc(classRef);
        if (classDoc.exists()) {
          setClassName(classDoc.data().className);
        }

        const userRef = doc(db, "users", uid);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
          const allHomeworks = userDoc.data().homeworks || [];
          const filtered = allHomeworks.filter(
            (hw) => hw.classUid === classUid
          );
          setHomeworks(filtered);
        }
      } catch (err) {
        console.error("Veri çekme hatası:", err.message);
      }
    };

    if (uid && classUid) fetchData();
  }, [uid, classUid]);

  const columns = [
    { header: "Tür", accessorKey: "homeworkType" },
    { header: "Ünite", accessorKey: "unit" },
    { header: "Not", accessorKey: "note" },
    { header: "Başlangıç", accessorKey: "startDate" },
    { header: "Bitiş", accessorKey: "endDate" },
  ];

  return (
    <Container>
      <BackButton onClick={() => navigate(-1)}>← Geri</BackButton>

      <ProfileCard>
        <h2>{className}</h2>
        <p>
          Bu sayfada sınıfınıza ait ödevlerinizi ve başarı sıralamanızı
          görebilirsiniz.
        </p>
      </ProfileCard>

      <GridContainer>
        <Card>
          <SectionTitleWrapper>
            <SectionTitle>📚 Ödevlerim</SectionTitle>
          </SectionTitleWrapper>

          {homeworks.length === 0 ? (
            <p>Bu sınıfa ait ödev bulunamadı.</p>
          ) : (
            <ReactTable2 data={homeworks} columns={columns} />
          )}
        </Card>

        <Card>
          <SectionTitle>🏆 Başarı Sıralamam</SectionTitle>
          <ClassRanking classUid={classUid} currentUserUid={uid} />
        </Card>
      </GridContainer>
    </Container>
  );
}

export default StudentClass;

// Styled Components
export const Container = styled.div`
  width: 100%;
  max-width: var(--main-width);
  margin: auto;
  padding: 1rem;
`;

export const BackButton = styled.button`
  background-color: var(--main-color);
  color: white;
  padding: 10px 16px;
  font-size: 0.95rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 16px;
  font-family: "MyCustomFont", sans-serif;

  &:hover {
    background-color: var(--accent-color);
  }
`;

export const ProfileCard = styled.div`
  background: var(--main-color);
  color: white;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  text-align: center;
`;

export const GridContainer = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`;

export const SectionTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const SectionTitle = styled.h3`
  font-size: 1.3rem;
  color: var(--main-color);
`;

export const GoButton = styled.button`
  background-color: var(--main-color);
  color: white;
  padding: 8px 12px;
  font-size: 0.85rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-family: "MyCustomFont", sans-serif;

  &:hover {
    background-color: var(--accent-color);
  }
`;
